import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, Output, TemplateRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CameraService } from 'src/services/camera.service';
import { ToastService } from 'src/services/toast.service';
import { GlobalService } from 'src/services/global.service';
import { IconModule } from '../icon/icon.module';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-input-image',
  templateUrl: './input-image.component.html',
  standalone: true,
  imports: [CommonModule, IconModule, ButtonComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputImageComponent),
      multi: true,
    },
  ],
})
export class InputImageComponent implements ControlValueAccessor {
  @Input()
  label?: string;

  @Input()
  labelTemplate?: TemplateRef<any>;

  @Input()
  error?: string;

  @Input()
  styleClass: string = '';

  @Input()
  boxStyleClass: string = '';

  @Output()
  remove = new EventEmitter<void>();

  @Output()
  preview = new EventEmitter<string>();

  pickImageError: string = '';

  set value(value: string) {
    this._value = value;
    this.onChange(value);
    this.onTouched(value);
  }
  get value(): string {
    return this._value;
  }

  private _value: string = '';
  private onChange: (value: string) => void = () => {};
  private onTouched: (value: string) => void = () => {};

  errorBoxStyleClass: Record<string, string> = {
    true: ErrorBoxStyleClass,
    false: '',
  };

  constructor(
    private cameraSvc: CameraService,
    private globalSvc: GlobalService,
  ) {}

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: (value: string) => void): void {
    this.onTouched = fn;
  }

  handleDragoverAvatar(event: DragEvent, htmlElement: HTMLElement) {
    event.preventDefault();
    htmlElement.classList.add('ondrag');
  }

  async handleSelectAvatar() {
    const base64 = await this.cameraSvc.selectImage();
    if (!base64) return;

    this.writeValue(base64);
  }

  async handleDropAvatar(event: DragEvent) {
    try {
      event.preventDefault();

      const file = event.dataTransfer?.files[0];
      if (!file) return;

      if (!file.type.includes('image')) {
        this.pickImageError =
          'Extension tidak dikenali. Coba gambar lain dengan format file JPG atau PNG';
        return;
      }

      const base64 = await this.cameraSvc.convertFileToBase64(file);
      this.writeValue(base64);
    } catch (error) {
      this.globalSvc.errorHandler(error, 'Gagal mengunggah gambar');
    }
  }

  removeImage() {
    this.writeValue('');
    this.remove.emit();
  }
}

const ErrorBoxStyleClass = '!border-line-danger-bold !bg-bg-danger-subtlest-default';
